export default __webpack_public_path__ + "static/media/68-min.657195c1.png";